import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import { API_BASE_URL } from '@/utils/api';
import { defaultQuestions, UserData, AdminQuestionItem, Question } from './quizData'; 
import Navbar from '../../components/Index/Navbar-simple'; 

// --- CSS STYLES (SAMA SEPERTI SEBELUMNYA) ---
const quizStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    :root { --primary-red: #FF0000; --bg-page: #F8F9FA; --card-bg: #FFFFFF; --text-dark: #212529; --text-gray: #6c757d; --border-light: #dee2e6; --navbar-height: 70px; --star-color: #FFD700; }
    * { box-sizing: border-box; }
    body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; background-color: var(--bg-page); }
    .fluenesia-app { background-color: var(--bg-page); height: 100vh; width: 100vw; font-family: 'Poppins', sans-serif; color: var(--text-dark); display: flex; flex-direction: column; overflow: hidden; position: relative; }
    .main-layout { display: flex; flex: 1; gap: 25px; width: 98%; max-width: 1800px; margin: 0 auto; padding: 20px; height: calc(100vh - var(--navbar-height)); overflow: hidden; }
    .sidebar { width: 320px; display: flex; flex-direction: column; gap: 20px; height: 100%; overflow-y: auto; padding-right: 5px; }
    .card { background: var(--card-bg); border-radius: 16px; padding: 20px; box-shadow: 0 4px 15px rgba(0,0,0,0.03); border: 1px solid rgba(0,0,0,0.03); flex-shrink: 0; }
    .timer-card { background-color: #FFE5E5; border-radius: 20px; padding: 25px 30px; text-align: left; border: none; display: flex; flex-direction: column; justify-content: center; }
    .timer-label { color: #FF0000; font-size: 18px; font-weight: 700; margin-bottom: 8px; }
    .timer-value { color: #000000; font-size: 28px; font-weight: 600; font-family: 'Poppins', sans-serif; letter-spacing: 1px; }
    .nav-card { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
    .nav-card-title { color: var(--primary-red); font-weight: 700; font-size: 18px; margin-bottom: 15px; }
    .nav-grid-scroll { flex: 1; overflow-y: auto; padding-right: 5px; }
    .nav-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; }
    .nav-item { aspect-ratio: 1; display: flex; align-items: center; justify-content: center; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; border: 1px solid var(--primary-red); background: white; color: var(--primary-red); transition: all 0.2s; }
    .nav-item:hover { background: #fff0f0; }
    .nav-item.active { background: var(--primary-red); color: white; transform: scale(1.05); }
    .nav-item.answered { background: var(--primary-red); color: white; opacity: 0.7; }
    .content-area { flex: 1; height: 100%; display: flex; flex-direction: column; overflow: hidden; }
    .question-card { background: var(--card-bg); border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.03); border: 1px solid #EAEAEA; width: 100%; height: 100%; display: flex; flex-direction: column; overflow: hidden; }
    .q-card-header { padding: 25px 30px; border-bottom: 1px solid #f0f0f0; flex-shrink: 0; }
    .q-title { color: var(--primary-red); font-weight: 700; font-size: 24px; margin: 0; }
    .q-card-body { flex: 1; padding: 30px 40px; overflow-y: auto; }
    .q-text { font-size: 18px; line-height: 1.6; color: #2c3e50; font-weight: 400; margin-bottom: 30px; text-align: justify; }
    .options-list { display: flex; flex-direction: column; gap: 12px; }
    .option-pill { display: flex; align-items: center; padding: 15px 25px; background: white; border: 1px solid var(--border-light); border-radius: 50px; cursor: pointer; transition: all 0.2s ease; width: 100%; }
    .option-pill:hover { border-color: var(--primary-red); background: #fffcfc; }
    .option-pill.selected { border-color: var(--primary-red); background: white; box-shadow: 0 0 0 1px var(--primary-red) inset; }
    .radio-circle { width: 22px; height: 22px; border-radius: 50%; border: 2px solid #ccc; margin-right: 20px; flex-shrink: 0; position: relative; }
    .option-pill.selected .radio-circle { border-color: var(--primary-red); }
    .option-pill.selected .radio-circle::after { content: ''; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 12px; height: 12px; background: var(--primary-red); border-radius: 50%; }
    .option-text { font-size: 16px; font-weight: 500; }
    .essay-input { width: 100%; padding: 20px; border-radius: 12px; border: 1px solid var(--border-light); min-height: 150px; font-size: 16px; resize: vertical; }
    .q-card-footer { padding: 20px 30px; background: #fff; border-top: 1px solid #f0f0f0; display: flex; justify-content: space-between; flex-shrink: 0; z-index: 10; }
    .btn-action { padding: 12px 35px; border-radius: 50px; font-weight: 700; font-size: 16px; cursor: pointer; transition: all 0.2s; border: none; min-width: 140px; }
    .btn-prev { background: #f1f3f5; color: #495057; }
    .btn-prev:hover { background: #e9ecef; }
    .btn-next { background: var(--primary-red); color: white; }
    .btn-next:hover { background: #d90000; }
    .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(8px); z-index: 9999; display: flex; align-items: center; justify-content: center; animation: fadeIn 0.3s ease; }
    .modal-box { background: white; width: 90%; max-width: 450px; border-radius: 24px; padding: 40px 30px; text-align: center; box-shadow: 0 20px 60px rgba(0,0,0,0.15); transform: scale(0.9); animation: popUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; position: relative; }
    .modal-icon-wrapper { width: 80px; height: 80px; background: #FFE5E5; color: var(--primary-red); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 36px; margin: 0 auto 20px auto; }
    .modal-title { font-size: 22px; font-weight: 700; margin-bottom: 10px; color: var(--text-dark); }
    .modal-desc { font-size: 16px; color: var(--text-gray); margin-bottom: 30px; line-height: 1.5; }
    .modal-highlight { color: var(--primary-red); font-weight: 600; }
    .modal-actions { display: flex; gap: 15px; justify-content: center; }
    .btn-modal { padding: 14px 28px; border-radius: 50px; font-weight: 600; cursor: pointer; border: none; font-size: 15px; flex: 1; transition: 0.2s; }
    .btn-modal-cancel { background: #F5F5F5; color: #666; }
    .btn-modal-cancel:hover { background: #E0E0E0; }
    .btn-modal-confirm { background: var(--primary-red); color: white; box-shadow: 0 8px 20px rgba(255, 0, 0, 0.25); }
    .btn-modal-confirm:hover { transform: translateY(-2px); box-shadow: 0 10px 25px rgba(255, 0, 0, 0.35); }
    .star-rating-container { display: flex; justify-content: center; gap: 10px; margin-bottom: 20px; }
    .star-icon { font-size: 38px; cursor: pointer; color: #E0E0E0; transition: transform 0.2s, color 0.2s; }
    .star-icon:hover { transform: scale(1.2); }
    .star-icon.active { color: var(--star-color); }
    .feedback-textarea { width: 100%; background: #FAFAFA; border: 2px solid #F0F0F0; border-radius: 16px; padding: 15px; font-family: 'Poppins', sans-serif; font-size: 14px; color: var(--text-dark); resize: none; height: 100px; margin-bottom: 25px; outline: none; transition: 0.3s; }
    .feedback-textarea:focus { border-color: var(--primary-red); background: white; }
    .feedback-textarea::placeholder { color: #BBB; }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes popUp { to { transform: scale(1); } }
    @media (max-width: 992px) { body, html, .fluenesia-app, .main-layout { height: auto; overflow: auto; } .main-layout { flex-direction: column; padding-bottom: 80px; } .sidebar { width: 100%; height: auto; } .question-card { height: auto; min-height: 500px; } .q-card-body { overflow: visible; } }
`;

const FluenesiaTest: React.FC = () => {
    const navigate = useNavigate();

    const [userData, setUserData] = useState<UserData | null>(null);
    const [questionList, setQuestionList] = useState<Question[]>([]); 
    const [currentIdx, setCurrentIdx] = useState<number>(0);
    const [answers, setAnswers] = useState<(string | number | null)[]>([]);
    const [timeLeft, setTimeLeft] = useState<number>(45 * 60); 
    const [isLoading, setIsDataLoading] = useState<boolean>(true);
    
    // --- STATE MODAL & FEEDBACK ---
    const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);
    const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false);
    
    const [feedbackRating, setFeedbackRating] = useState<number>(0);
    const [feedbackMessage, setFeedbackMessage] = useState<string>("");
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    useEffect(() => {
        void (async () => {
        const hasTaken = localStorage.getItem('fluenesia_test_taken');
        if (hasTaken === 'true') {
            alert("Anda sudah pernah mengerjakan tes ini.");
            navigate('/assessment/free-test'); 
            return;
        }

        const storedUser = localStorage.getItem('user');
        const parsedUser: UserData = storedUser ? JSON.parse(storedUser) : { id: 99, name: 'Guest User' };
        setUserData(parsedUser);

        let finalQuestions: Question[] = [];

        try {
            const response = await axios.get(`${API_BASE_URL}/questions`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            const parsedAdminData: AdminQuestionItem[] = response.data.data || [];
            finalQuestions = parsedAdminData.map(q => {
                const correctIndex = ['A', 'B', 'C', 'D'].indexOf(q.correctAnswer);
                return {
                    id: q.id,
                    questionNumber: q.questionNumber,
                    type: q.type as any,
                    question: q.questionText,
                    options: q.type !== 'essay' ? [q.optionA, q.optionB, q.optionC, q.optionD] : [],
                    correct: correctIndex >= 0 ? correctIndex : 0,
                    keyAnswer: q.referenceAnswer,
                    explanation: "",
                    audioText: q.audioText
                };
            });
        } catch (error) {
            console.error('Gagal mengambil soal dari database:', error);
        }
        if (finalQuestions.length === 0) finalQuestions = defaultQuestions;

        setQuestionList(finalQuestions);
        setAnswers(new Array(finalQuestions.length).fill(null));
        setIsDataLoading(false);
        })();
    }, [navigate]);

    useEffect(() => {
        if (isLoading || !userData) return;
        const interval = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    forceFinish(); 
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(interval);
    }, [isLoading, userData]);

    const formatTime = (seconds: number) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m} : ${s}`;
    };

    const handleAnswer = (val: string | number) => {
        const newAnswers = [...answers];
        newAnswers[currentIdx] = val;
        setAnswers(newAnswers);
    };

    const handleInitialSubmit = () => {
        setShowSubmitModal(true);
    };

    const proceedToFeedback = () => {
        setShowSubmitModal(false);
        setShowFeedbackModal(true); 
    };

    // --- FUNGSI UTAMA: SUBMIT KE DATABASE ---
    const submitFinalData = async () => {
        if (feedbackRating === 0) {
            alert("Mohon berikan rating bintang terlebih dahulu.");
            return;
        }

        setIsSubmitting(true);

        // 1. Hitung Skor
        let correctCount = 0;
        questionList.forEach((q, i) => {
            if (q.type !== 'essay' && answers[i] === q.correct) correctCount++;
        });
        const finalScore = Math.round((correctCount / questionList.length) * 100);

        // 2. Tentukan Level
        let finalLevel = "BASIC";
        if (finalScore >= 80) finalLevel = "PROFICIENT";
        else if (finalScore >= 50) finalLevel = "INDEPENDENT";

        try {
            if (userData && userData.id) {
                // Gunakan Promise.all agar data tersimpan paralel
                await Promise.all([
                    // Kirim Hasil Tes
                    axios.post(`${API_BASE_URL}/assessments/submit`, {
                        userId: userData.id,
                        score: finalScore,
                        level: finalLevel,
                        answers: answers 
                    }),
                    // Kirim Feedback
                    axios.post(`${API_BASE_URL}/assessments/feedback`, {
                        userId: userData.id,
                        rating: feedbackRating,
                        message: feedbackMessage
                    })
                ]);
            }

            // 3. Simpan Status Local & Navigasi
            localStorage.setItem('fluenesia_test_taken', 'true');
            navigate('/result', { state: { score: finalScore, level: finalLevel, answers: answers, userData: userData } });

        } catch (error) {
            console.error("Gagal mengirim data ke server:", error);
            // Tetap lanjut ke hasil meskipun server error (UX)
            localStorage.setItem('fluenesia_test_taken', 'true');
            navigate('/result', { state: { score: finalScore, level: finalLevel, answers: answers, userData: userData } });
        } finally {
            setIsSubmitting(false);
        }
    };

    const forceFinish = () => {
        setShowSubmitModal(false);
        setShowFeedbackModal(false);
        let correctCount = 0;
        questionList.forEach((q, i) => {
            if (q.type !== 'essay' && answers[i] === q.correct) correctCount++;
        });
        const finalScore = Math.round((correctCount / questionList.length) * 100);
        localStorage.setItem('fluenesia_test_taken', 'true');
        navigate('/result', { state: { score: finalScore, answers: answers, userData: userData } });
    }

    const filledCount = answers.filter(a => a !== null && a !== "").length;
    const isAllAnswered = filledCount === questionList.length;

    if (isLoading) return <div style={{padding: 50, textAlign:'center'}}>Memuat...</div>;
    if (questionList.length === 0) return <div>Tidak ada soal.</div>;

    const currentQ = questionList[currentIdx];

    return (
        <div className="fluenesia-app">
            <style>{quizStyles}</style>
            
            <Navbar />

            {/* --- MODAL 1: KONFIRMASI SUBMIT --- */}
            {showSubmitModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <div className="modal-icon-wrapper">
                            {isAllAnswered ? "🚀" : "⚠️"}
                        </div>
                        <h3 className="modal-title">
                            {isAllAnswered ? "Siap Mengumpulkan?" : "Yakin ingin Submit?"}
                        </h3>
                        <p className="modal-desc">
                            {isAllAnswered ? (
                                <>Hebat! Kamu telah menjawab <span className="modal-highlight">semua soal</span>. Apakah kamu yakin ingin menyelesaikan tes ini?</>
                            ) : (
                                <>Ups! Kamu baru menjawab <span className="modal-highlight">{filledCount} dari {questionList.length}</span> soal. Masih ada soal yang kosong.</>
                            )}
                        </p>
                        <div className="modal-actions">
                            <button className="btn-modal btn-modal-cancel" onClick={() => setShowSubmitModal(false)}>
                                Cek Lagi
                            </button>
                            <button className="btn-modal btn-modal-confirm" onClick={proceedToFeedback}>
                                Ya, Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- MODAL 2: FEEDBACK (RATING & MESSAGE) --- */}
            {showFeedbackModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h3 className="modal-title" style={{marginBottom: '5px'}}>Bagaimana Pengalamanmu?</h3>
                        <p className="modal-desc" style={{fontSize: '14px', marginBottom: '20px'}}>
                            Beri rating dan masukan untuk kami sebelum melihat hasil.
                        </p>
                        
                        <div className="star-rating-container">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span 
                                    key={star}
                                    className={`star-icon ${star <= feedbackRating ? 'active' : ''}`}
                                    onClick={() => setFeedbackRating(star)}
                                >
                                    ★
                                </span>
                            ))}
                        </div>

                        <textarea 
                            className="feedback-textarea" 
                            placeholder="Tulis pesan atau saran untuk Fluenesia..."
                            value={feedbackMessage}
                            onChange={(e) => setFeedbackMessage(e.target.value)}
                        />

                        <div className="modal-actions">
                            <button 
                                className="btn-modal btn-modal-confirm" 
                                onClick={submitFinalData}
                                disabled={isSubmitting}
                                style={{ opacity: isSubmitting ? 0.7 : 1, cursor: isSubmitting ? 'not-allowed' : 'pointer' }}
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Kirim & Lihat Hasil'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="main-layout">
                {/* SIDEBAR */}
                <div className="sidebar">
                    <div className="timer-card">
                        <div className="timer-label">Time Remaining</div>
                        <div className="timer-value">{formatTime(timeLeft)}</div>
                    </div>

                    <div className="card nav-card">
                        <div className="nav-card-title">Questions</div>
                        <div className="nav-grid-scroll">
                            <div className="nav-grid">
                                {questionList.map((_, i) => (
                                    <div 
                                        key={i} 
                                        className={`nav-item ${i === currentIdx ? 'active' : ''} ${answers[i] !== null && i !== currentIdx ? 'answered' : ''}`} 
                                        onClick={() => setCurrentIdx(i)}
                                    >
                                        {questionList[i].questionNumber || i + 1}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* KONTEN KANAN */}
                <div className="content-area">
                    <div className="question-card">
                        <div className="q-card-header">
                            <h2 className="q-title">Question {currentQ.questionNumber || currentIdx + 1}</h2>
                        </div>

                        <div className="q-card-body">
                            <div className="q-text">
                                {currentQ.question}
                                {currentQ.type === 'listening' && (
                                    <div style={{marginTop: '10px', color: '#666', fontStyle: 'italic', fontSize: '14px'}}>
                                        (Audio Listening Section)
                                    </div>
                                )}
                            </div>

                            {currentQ.type === 'essay' ? (
                                <textarea 
                                    className="essay-input" 
                                    value={(answers[currentIdx] as string) || ''} 
                                    onChange={(e) => handleAnswer(e.target.value)} 
                                    placeholder="Type your answer here..."
                                />
                            ) : (
                                <div className="options-list">
                                    {currentQ.options?.map((opt: string, i: number) => (
                                        <div 
                                            key={i} 
                                            className={`option-pill ${answers[currentIdx] === i ? 'selected' : ''}`} 
                                            onClick={() => handleAnswer(i)}
                                        >
                                            <div className="radio-circle"></div>
                                            <div className="option-text">{opt}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="q-card-footer">
                            <button 
                                className="btn-action btn-prev" 
                                onClick={() => setCurrentIdx(prev => Math.max(0, prev - 1))}
                                disabled={currentIdx === 0}
                            >
                                Previous
                            </button>

                            {currentIdx === questionList.length - 1 ? (
                                <button 
                                    className="btn-action btn-next" 
                                    onClick={handleInitialSubmit}
                                >
                                    Submit
                                </button>
                            ) : (
                                <button 
                                    className="btn-action btn-next" 
                                    onClick={() => setCurrentIdx(prev => Math.min(questionList.length - 1, prev + 1))}
                                >
                                    Next
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FluenesiaTest;